import { getCurrentInstance, computed } from 'vue';
import { SprintState } from '@/types/sprint';
import { getSprintKey } from '@/utilities/sprintKeys';

export default function useCheckSprintState(card: any) {
  const _this = getCurrentInstance()?.proxy as any;
  if (!_this) return;

  const cancelledOrCompletedSprint = computed(() => {
    const _card = card.value || card;
    const projectId = _card?.project_id;
    const sprintId = _card?.sprint_id;

    if (!projectId || !sprintId) return false;
    const sprintKey = getSprintKey(projectId, sprintId);
    const cardSprint = _this.$store.getters.getSpaceSprints(projectId)[sprintKey];
    return [SprintState.Completed, SprintState.Canceled].includes(cardSprint?.state);
  });

  return {
    cancelledOrCompletedSprint,
  };
}
